"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeywordsTreesData = exports.TreeData = exports.displayedTreesCategories = void 0;
// eslint-disable-next-line import/no-cycle
var trees_1 = require("./firebaseRecords/trees");
var languages_1 = require("./languages");
var pathResolutionError_1 = __importDefault(require("./pathResolutionError"));
var paths_1 = require("./paths");
exports.displayedTreesCategories = [
    'Autre',
    'Baux commerciaux',
    'Concurrence',
    'Consommation',
    'Distribution',
    'Droit européen des affaires',
];
// TODO: duplicated with public/utils; Centralize in @livv/utils and remove duplicates
// https://thetribeio.atlassian.net/browse/VOG-1813
function convertToRoman(numRef) {
    var e_1, _a;
    var num = numRef;
    var roman = {
        M: 1000, // order by decreasing value required
        CM: 900,
        D: 500,
        CD: 400,
        C: 100,
        XC: 90,
        L: 50,
        XL: 40,
        X: 10,
        IX: 9,
        V: 5,
        IV: 4,
        I: 1,
    };
    var str = '';
    try {
        for (var _b = __values(Object.keys(roman)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var i = _c.value;
            var q = Math.floor(num / roman[i]);
            num -= q * roman[i];
            str += i.repeat(q);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return str;
}
var convertToRomanMinLetter = function (num) { return convertToRoman(num).toLowerCase(); };
var convertToMajLetter = function (num) { return String.fromCharCode(64 + num); };
var convertToMinLetter = function (num) { return String.fromCharCode(96 + num); };
var convertToInteger = function (num) { return num.toString(); };
var typoFormatters = [
    [function (i) { return "Livre ".concat(i); }, convertToInteger],
    [function (i) { return "Partie ".concat(i); }, convertToInteger],
    [function (i) { return "Titre ".concat(i); }, convertToInteger],
    [function (i) { return "Chapitre ".concat(i); }, convertToInteger],
    [function (i) { return "Section ".concat(i); }, convertToInteger],
    [function (i) { return i; }, convertToRoman],
    [function (i) { return i; }, convertToMajLetter],
    [function (i) { return "".concat(i, "\u00B0"); }, convertToInteger],
    [function (i) { return "".concat(i, ")"); }, convertToMinLetter],
    [function (i) { return "".concat(i, ")"); }, convertToRomanMinLetter],
];
var typoFormattersEN = [
    [function (i) { return "Book ".concat(i); }, convertToInteger],
    [function (i) { return "Part ".concat(i); }, convertToInteger],
    [function (i) { return "Title ".concat(i); }, convertToInteger],
    [function (i) { return "Chapter ".concat(i); }, convertToInteger],
    [function (i) { return "Section ".concat(i); }, convertToInteger],
    [function (i) { return i; }, convertToRoman],
    [function (i) { return i; }, convertToMajLetter],
    [function (i) { return "".concat(i, "\u00B0"); }, convertToInteger],
    [function (i) { return "".concat(i, ")"); }, convertToMinLetter],
    [function (i) { return "".concat(i, ")"); }, convertToRomanMinLetter],
];
var typoFormatter = function (level, language) {
    return language === 'EN'
        ? typoFormattersEN[Math.min(level, typoFormatters.length - 1)]
        : typoFormatters[Math.min(level, typoFormatters.length - 1)];
};
var formatRawIndexes = function (indexes) {
    // inside introduction
    if (indexes[0] === 0) {
        if (indexes.length === 1)
            return [];
        return __spreadArray([-1, 'Intro'], __read(indexes.slice(1)), false);
    }
    return __spreadArray([indexes[0] - 1], __read(indexes.slice(1)), false);
};
var formatIndex = function (level, index, language, dummyLevel) {
    if (dummyLevel === void 0) { dummyLevel = false; }
    if (typeof index === 'string')
        return index;
    if (index === -1)
        return false;
    return typoFormatter(dummyLevel ? level + 1 : level, language)[1](index + 1);
};
var generateTypography = function (rawIndexes, 
// eslint-disable-next-line default-param-last
full, language, dummyLevel) {
    if (full === void 0) { full = false; }
    if (dummyLevel === void 0) { dummyLevel = false; }
    var indexes = formatRawIndexes(rawIndexes);
    var level = indexes.length - 1;
    if (level < 0)
        return '';
    var formattedIndexes = full
        ? indexes
            .map(function (i, l) { return formatIndex(l, i, language, dummyLevel); })
            .filter(function (i) { return i; })
            .join('.')
        : formatIndex(level, indexes[indexes.length - 1], language, dummyLevel) || '';
    return typoFormatter(dummyLevel ? level + 1 : level, language)[0](formattedIndexes);
};
var insert = function (arr, index, newItem) { return __spreadArray(__spreadArray(__spreadArray([], __read(arr.slice(0, index)), false), [
    newItem
], false), __read(arr.slice(index)), false); };
var TreeData = /** @class */ (function () {
    function TreeData(content, title, theme) {
        this.idList = [];
        this.content = Array.isArray(content) ? content : trees_1.TreeContent.toRaw(content);
        this.theme = theme;
        this.title = title;
    }
    TreeData.prototype.treeContent = function () {
        return trees_1.TreeContent.fromRaw(this.content);
    };
    TreeData.prototype.getNode = function (path, byTitle) {
        try {
            return TreeData._getNode(new paths_1.Path(path), this.content, byTitle);
        }
        catch (e) {
            console.error(JSON.stringify(e));
            throw new Error("Path ".concat(path.join('.'), " not found in tree ").concat(this.title));
        }
    };
    TreeData.prototype.getNodesIdList = function () {
        if (this.idList.length)
            return this.idList;
        this.idList = this._getNodeIdList();
        return this.idList;
    };
    TreeData.prototype.getPublishedNodesPaths = function () {
        return TreeData.getPublishedNodes(this.content);
    };
    TreeData.prototype.getLocalNodeTypography = function (path, language, dummyLevel) {
        return generateTypography(TreeData._getPathIndexes(new paths_1.Path(path), this.content), false, language, dummyLevel);
    };
    TreeData.prototype.getFullNodeTypography = function (path, language, dummyLevel) {
        if (language === void 0) { language = languages_1.LanguageUppercase.FR; }
        if (dummyLevel === void 0) { dummyLevel = false; }
        return generateTypography(TreeData._getPathIndexes(new paths_1.Path(path), this.content), true, language, dummyLevel);
    };
    TreeData.prototype.getIndexes = function (path) {
        // TODO should use formatIndexes
        return TreeData._getPathIndexes(new paths_1.Path(path), this.content);
    };
    TreeData.prototype.getDepth = function (path) {
        return this.getIndexes(path).length;
    };
    TreeData.prototype.getPathTitles = function (path) {
        var _this = this;
        try {
            return path.map(function (_, index) { return _this.getNode(path.slice(0, index + 1)).title; });
        }
        catch (error) {
            console.error('Failed to get path titles', { error: error, path: path });
            throw new Error("Failed to get path titles for path ".concat(path.join('.'), " in tree ").concat(this.title));
        }
    };
    TreeData.prototype.getPathTitlesWithTypos = function (path, language, dummyLevel) {
        var _this = this;
        return path.map(function (_, index) {
            var subpath = path.slice(0, index + 1);
            var title = _this.getNode(subpath).title;
            var typo = _this.getLocalNodeTypography(subpath, language, dummyLevel);
            return { subpath: subpath, title: title, typo: typo };
        });
    };
    TreeData.prototype.getPathIds = function (pathTitles) {
        var _this = this;
        return pathTitles.map(function (_, index) { return _this.getNode(pathTitles.slice(0, index + 1), true).id; });
    };
    TreeData.prototype.addNode = function (node, path, index) {
        this.content = TreeData._transformChildrenOf(new paths_1.Path(path), this.content, function (children) {
            return typeof index === 'number' ? insert(children, index, node) : __spreadArray(__spreadArray([], __read(children), false), [node], false);
        });
    };
    TreeData.prototype.removeNode = function (pathArg) {
        var path = new paths_1.Path(pathArg);
        var nodeId = path.nodeId();
        this.content = TreeData._transformChildrenOf(path.parentPath(), this.content, function (children) {
            return children.filter(function (_a) {
                var id = _a.id;
                return id !== nodeId;
            });
        });
    };
    TreeData.prototype.moveNode = function (path, newParentPath, newIndex) {
        var node = this.getNode(path);
        this.removeNode(path);
        this.addNode(node, newParentPath, newIndex);
        var parentPath = new paths_1.Path(path).parentPath();
        var nextParentPath = new paths_1.Path(newParentPath);
        return TreeData._collectNodeDescendants(node, function (_a) {
            var relativePath = _a.path;
            return [
                parentPath.descendantPath(relativePath).ids,
                nextParentPath.descendantPath(relativePath).ids,
            ];
        });
    };
    TreeData.prototype.replaceNode = function (node, pathArg) {
        var path = new paths_1.Path(pathArg);
        this.content = TreeData._transformChildrenOf(path.parentPath(), this.content, function (children) {
            return children.map(function (child) { return (child.id === path.nodeId() ? __assign(__assign({}, child), node) : child); });
        });
    };
    TreeData.prototype.getDescendantsPaths = function (pathArg) {
        var parentPath = new paths_1.Path(pathArg).parentPath();
        return TreeData._collectNodeDescendants(this.getNode(pathArg), function (_a) {
            var relativePath = _a.path;
            return parentPath.descendantPath(relativePath).ids;
        });
    };
    TreeData.prototype.getPathFromId = function (nodeId, nodes) {
        var e_2, _a;
        if (nodes === void 0) { nodes = this.content; }
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var currentNode = nodes_1_1.value;
                if (currentNode.id === nodeId)
                    return [nodeId];
                if (currentNode.children && currentNode.children.length) {
                    var found = this.getPathFromId(nodeId, currentNode.children);
                    if (found.length)
                        return __spreadArray([currentNode.id], __read(found), false);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [];
    };
    TreeData.prototype.getSearchMatches = function (cleaningMethod, searchQuery, nodes) {
        var _this = this;
        if (nodes === void 0) { nodes = this.content; }
        if (!searchQuery)
            return [];
        return nodes.reduce(function (matches, node) {
            var _a;
            var nodeMatches = [];
            var titleMatch = node.title && cleaningMethod(node.title).includes(cleaningMethod(searchQuery));
            if (titleMatch)
                nodeMatches.push(node.id);
            if ((_a = node === null || node === void 0 ? void 0 : node.children) === null || _a === void 0 ? void 0 : _a.length)
                nodeMatches.push.apply(nodeMatches, __spreadArray([], __read(_this.getSearchMatches(cleaningMethod, searchQuery, node.children)), false));
            return __spreadArray(__spreadArray([], __read(matches), false), __read(nodeMatches), false);
        }, []);
    };
    TreeData.prototype._getNodeIdList = function (nodes) {
        var _this = this;
        if (nodes === void 0) { nodes = this.content; }
        return nodes.reduce(function (list, node) {
            var _a;
            var childrenIds = ((_a = node === null || node === void 0 ? void 0 : node.children) === null || _a === void 0 ? void 0 : _a.length) ? _this._getNodeIdList(node.children) : [];
            return __spreadArray(__spreadArray(__spreadArray([], __read(list), false), [node.id], false), __read(childrenIds), false);
        }, []);
    };
    TreeData._getNode = function (path, nodes, byTitle) {
        var _a = __read(path.popRoot(), 2), nodeId = _a[0], nextPath = _a[1];
        var node = nodes.find(function (_a) {
            var id = _a.id, title = _a.title;
            return (byTitle ? title === nodeId : id === nodeId);
        });
        if (!node) {
            throw new Error("Node ".concat(nodeId, " not found"));
        }
        if (nextPath.empty()) {
            return node;
        }
        if (!node.children)
            throw new Error("Remaining path ".concat(JSON.stringify(path), " is not found. Node ").concat(JSON.stringify(node), " does not have children."));
        return this._getNode(nextPath, node.children, byTitle);
    };
    TreeData._transformChildrenOf = function (path, 
    // eslint-disable-next-line default-param-last
    nodes, callback) {
        var _this = this;
        if (nodes === void 0) { nodes = []; }
        if (path.empty())
            return callback(nodes);
        var _a = __read(path.popRoot(), 2), nodeId = _a[0], nextPath = _a[1];
        var node = nodes.find(function (_a) {
            var id = _a.id;
            return id === nodeId;
        });
        if (!node)
            throw new pathResolutionError_1.default("Inconsistency: no node for remaining path ".concat(path.toString()));
        return nodes.map(function (root) {
            return root === node
                ? __assign(__assign({}, root), { children: _this._transformChildrenOf(nextPath, root.children, callback) }) : root;
        });
    };
    TreeData._collectNodeDescendants = function (node, callback, parentPath) {
        var _a;
        var _this = this;
        if (parentPath === void 0) { parentPath = new paths_1.Path([]); }
        var path = parentPath.childPath(node.id);
        return (_a = [callback({ node: node, path: path })]).concat.apply(_a, __spreadArray([], __read((node.children || []).map(function (child) {
            return _this._collectNodeDescendants(child, callback, path);
        })), false));
    };
    TreeData._getPathIndexes = function (path, nodes, parentIndexes) {
        if (parentIndexes === void 0) { parentIndexes = []; }
        var _a = __read(path.popRoot(), 2), nodeId = _a[0], nextPath = _a[1];
        var index = nodes.findIndex(function (_a) {
            var id = _a.id;
            return id === nodeId;
        });
        if (index === -1)
            throw new Error("Can't find node with id ".concat(nodeId, ", at level ").concat(parentIndexes.length, ": nodes have ids ").concat(nodes.map(function (_a) {
                var id = _a.id;
                return id;
            })));
        var indexes = __spreadArray(__spreadArray([], __read(parentIndexes), false), [index], false);
        if (nextPath.empty()) {
            return indexes;
        }
        var node = nodes[index];
        if (!node.children)
            throw new Error("Node ".concat(nodeId, " doesn't have children, cannot get indexes"));
        return this._getPathIndexes(nextPath, node.children, indexes);
    };
    TreeData.getPublishedNodes = function (nodes, parentPath) {
        if (parentPath === void 0) { parentPath = []; }
        return nodes.reduce(function (publishedNodes, node) {
            var children = node.children, id = node.id, isPublished = node.isPublished;
            var nodePath = __spreadArray(__spreadArray([], __read(parentPath), false), [id], false);
            var publishedPaths = [];
            if (isPublished) {
                publishedPaths.push(nodePath);
            }
            if (children === null || children === void 0 ? void 0 : children.length) {
                publishedPaths.push.apply(publishedPaths, __spreadArray([], __read(TreeData.getPublishedNodes(children, nodePath)), false));
            }
            publishedNodes.push.apply(publishedNodes, __spreadArray([], __read(publishedPaths), false));
            return publishedNodes;
        }, []);
    };
    return TreeData;
}());
exports.TreeData = TreeData;
var getKeywordsTreesData = function (keywordsTrees) {
    return keywordsTrees.reduce(function (acc, tree) {
        acc[tree.id] = new TreeData(tree.content, tree.title, tree.theme);
        return acc;
    }, {});
};
exports.getKeywordsTreesData = getKeywordsTreesData;
//# sourceMappingURL=treeDatas.js.map